import { graphqlClient } from '@/lib/graphql-client';
import { buildGetActivityLogsQuery } from '../graphql/queries';
import { ActivityLogsPagingResult, GetActivityLogsParams } from '../types/activity-log.types';

export const getActivityLogs = async (
  params: GetActivityLogsParams
): Promise<{ ActivityLogs: ActivityLogsPagingResult }> => {
  const { pageNo, pageSize, filter = {}, order } = params;
  return graphqlClient.query({
    query: buildGetActivityLogsQuery(filter, pageNo, pageSize, order),
  }) as Promise<{ ActivityLogs: ActivityLogsPagingResult }>;
};
